import { isPast } from 'date-fns';

export function hasTokenExpired(expiryDate: string | number | Date) {
  return isPast(expiryDate);
}
